<template>
  <div class="modal pretty-scrollbar" :class="modifiers">
    <div class="modal__content">
      <div v-if="hasCloseButton" class="modal__close">
        <button
          type="button"
          class="modal__cross"
          @click="close"
        />
      </div>
      <slot />
      <div v-if="actions.length" class="modal__actions">
        <BaseButton
          v-for="(item, i) in actions"
          :key="`modal_action_${i}`"
          v-bind="item"
          class="modal__action"
          @click="item.action ? item.action() : null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'BaseModal',
  components: {
    BaseButton,
  },
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
    isMiddle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        modal_middle: this.isMiddle,
      };
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus">
.modal
  display flex
  flex-flow row wrap
  justify-content center
  background alpha($c_text, 95%)
  overflow-y auto
  overflow-x hidden
  padding 1.25em
  color #fff

  &_middle
    align-items center

  &__content
    position relative
    display block
    width 44em
    max-width 100%
    padding 2em
    background-color #fff
    color $c_text
    align-self flex-start
    border-radius 0.2em
    animation fadeInBottom 500ms ease both
    ~/_middle &
      align-self center

  &__close
    abs top left 100%
    width 2.4em
    height @width
    margin (@height / 2 * -1) 0 0 (@width / 2)
    z-index 5

  &__cross
    display block
    width 100%
    height 100%
    padding 0
    margin 0
    border 0
    outline none
    background url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cpath d='M26 26L6 6M26 6L6 26' stroke-linecap='round' stroke='%23fff' stroke-width='3'/%3E%3C/svg%3E") no-repeat center
    background-size 52%
    box-shadow inset 0 0 0 0.1em $c_text_dim
    border-radius 50%

  &__actions
    margin-top 2em
    text-align center

  &__action
    margin-left 0.4em
    margin-right @margin-left
</style>
